import { Component } from '@angular/core';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { IServicio } from 'src/app/models/monitoreo-servicios/monitoreo-servicios.model';
import { MonitoreoServiciosService } from 'src/app/shared/services/monitoreo-servicios.service';
import { takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ServiceDetailDialogComponent } from './service-detail-dialog/service-detail-dialog.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { Router } from '@angular/router';
import { ESystemProfileList } from 'src/app/enum/EAccess';

@Component({
  selector: 'app-monitoreo-servicios',
  templateUrl: './monitoreo-servicios.component.html',
  styleUrls: ['./monitoreo-servicios.component.scss'],
})
export class MonitoreoServiciosComponent {
    public readonly STATUSES = {
        DISPONIBLE: 'Disponible',
        INTERMITENTE: 'Intermitente',
        FUERA_SERVICIO: 'Fuera de Servicio',
    }

    private destroy$ = new Subject<void>();

	private servicios: IServicio[] = [];
    public filteredServicios: IServicio[] = [];
	public isServiciosLoading = false;

    public statusControl = new FormControl<string>('');

  	constructor(
		private monitoreoServiciosService: MonitoreoServiciosService,
		private alertService: AlertService,
        private dialog: MatDialog,
		private _sessionService: SessionService,
		private _router: Router,
	) {}

	ngOnInit() {
        if (!this.checkAccess()) {
            this._router.navigate(['/request-access'])
            return;
        }

		this.listServices();

        this.statusControl.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.filteredServicios = this.servicios.filter(servicio => servicio.estado === value || !value);
            });
	}

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    checkAccess() {
        return this._sessionService
			.getUserProfileList()
			.includes(ESystemProfileList.WEB);
    }

	listServices() {
		this.isServiciosLoading = true;
		this.statusControl.reset();
		this.monitoreoServiciosService.listServices().subscribe({
			next: (res) => {
                this.servicios = res;
                this.filteredServicios = this.servicios;
				this.isServiciosLoading = false;
			},
			error: ({error}) => {
				this.alertService.error(error.message || 'Ocurrió un error al intentar obtener los servicios.');
				this.isServiciosLoading = false;
			},
		});
	}

	getChipColorClass(status: string): string {
		switch (status) {
			case this.STATUSES.DISPONIBLE:
				return 'available-chip';
			case this.STATUSES.INTERMITENTE:
				return 'warning-chip';
			case this.STATUSES.FUERA_SERVICIO:
				return 'error-chip';
			default:
				return '';
		}
	}

	getStatusIcon(status: string): string {
		switch (status) {
			case this.STATUSES.DISPONIBLE:
				return 'check_circle';
			case this.STATUSES.INTERMITENTE:
				return 'error';
			case this.STATUSES.FUERA_SERVICIO:
				return 'cancel';
			default:
				return '';
		}
	}

    openServiceDialog(servicio: IServicio) {
        this.dialog.open(ServiceDetailDialogComponent, {
            minWidth: '500px',
            data: servicio
        });
    }
}
